<template>
  <div
    class="m-assembly top-nav"
    :style="{
      backgroundColor: extras.introduction ? extras.introduction.bg : '#f5f6f7',
    }"
    v-if="extras.introduction && extras.introduction.display == 1"
    id="introduction"
  >
    <WapTitle
      :style="{
        color: extras.introductionTitle ? extras.introductionTitle.color : '',
        backgroundColor: extras.introductionTitle
          ? extras.introductionTitle.bg
          : '',
      }"
      v-if="extras.introductionTitle && extras.introductionTitle.display == 1"
      :title="extras.introductionTitle.introductionTitleVal"
      :icon="icon"
    />
    <div class="no-data" v-if="seminarInfo.desc.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
    <div
      class="g-intrd-html"
      v-html="seminarInfo.descWap ? seminarInfo.descWap : seminarInfo.desc"
      :style="{
        color: extras.introductionDescription
          ? extras.introductionDescription.color
          : '',
        backgroundColor: extras.introductionDescription
          ? extras.introductionDescription.bg
          : '',
      }"
      v-if="
        extras.introductionDescription &&
        extras.introductionDescription.display == 1
      "
    ></div>
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";

export default {
  components: {
    WapTitle,
  },
  props: {
    seminarInfo: Object,
    extras: Object,
  },
  data() {
    return {
      title: "大会介绍",
      icon: require("@/assets/images/wap/dahui.png"),
    };
  },
};
</script>

<style scoped></style>
